<template>
    <div style="background-color: white;box-sizing:unset;min-width:1600px">
        <headers></headers>
        <!-- 中间内容区域开始 -->
         <!-- 中文版 -->
        <div v-if="langluageType != 'en'" class="window_con">
            <div class="window_banner">
                <img src="../assets/propaganda/articleAI.jpg" class="window_banner_img">
                <div class="banner_text">
                    <img src="../assets/propaganda/AI_logo.svg" class="banner_text_img">
                    <h1 style="height: 70px;">会展人自己的人工智能服务平台</h1>
                    <ul class="banner_ul">
                        <li><a href="#">敬&nbsp;请&nbsp;期&nbsp;待</a></li>
                    </ul>
                </div>
            </div>
            <div class="article">
                <div style="height: 120px;"></div>
                <h1>智能云的解决方案</h1>
                <div class="tit_con">
                    <p>基于覆盖全产业链的会展大数据，借助机器学习、语音识别、自然语言处理等人工智能（A.I.）领域的前卫技术，</p>
                    <p>为您提供个性化的整合、分析、开发、延展等服务，助您完成精准营销、客群定位、智能服务、智慧管理等目标，最终让会展行业更“智慧”</p>
                </div>
                <div style="height: 120px;"></div>
            </div>
        </div>
        <!-- 英文版 -->
        <div v-else class="window_con">
            <div class="window_banner">
                <img src="../assets/propaganda/articleAI1.jpg" class="window_banner_img">
                <div class="banner_text">
                    <img src="../assets/propaganda/AI_logo.svg" class="banner_text_img">
                    <h1 style="height: 70px;margin-bottom: 25px;">For the Future Expo</h1>
                    <!-- <ul class="banner_ul">
                        <li><a href="#">Expect</a></li>
                    </ul> -->
                </div>
            </div>
            <div class="article">
                <div style="height: 0;"></div>
                <!-- <h1>A.I.cloud solutions</h1> -->
                <div class="tit_con" style="margin-top:70px;margin-bottom: 30px;font-weight: 700;">
                    <p>Expo A.I. will gather rich data resources from the whole industry chain of the exhibition industry and utilize cutting-edge technologies in the field of artificial intelligence, such as</p>
                    <p style="margin-bottom: 20px;">machine learning, speech recognition and natural language processing.</p>
                    <p>In the future, Expo A.I. will be committed to providing more personalized integration, analysis, development and expansion services to achieve the goals of precise marketing,</p>
                    <p>customer orientation, intelligent services, intelligent management, etc., so as to promote the development of the exhibition industry to a higher level of intelligence.</p>
                </div>
                <div style="height: 70px;"></div>
            </div>
        </div>
        <!-- 中间内容区域结束 -->
        <footers></footers>
        <contact></contact>
    </div>
</template>
<script>
  import headers from '@/components/Header';
  import footers from '@/components/Footer';
  import contact from '@/components/contact';

export default {
    components: {
      headers,
      footers,
      contact
    },
    data(){
        return {
            langluageType:sessionStorage.getItem('langluageType')||'ch'
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/page/articleAi.vue